import { Component } from '@angular/core';
import { OERIService } from '../../../../services/oeri.service';
import { TableModule } from 'primeng/table';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { CommonService } from '../../../../services/common.service';
import { FormsModule, NgModel } from '@angular/forms';
import { ReportsService } from '../../../../services/reports.service';
import saveAs from 'file-saver';
import { NotificationService } from '../../../../services/notification.service';

@Component({
    selector: 'app-orphaned-tlrreports',
    imports: [TableModule, NgIf, DropdownModule, CommonModule, FormsModule, RouterModule],
    templateUrl: './orphaned-tlrreports.component.html',
    styleUrl: './orphaned-tlrreports.component.scss'
})
export class OrphanedTlrreportsComponent {

  isShowMainBlock: boolean = false;
  divisionList = []
  sectionsList = []
  plantList = []
  reportData: any = [];
  filters = {
    division: 'ALL',
    section: 'ALL',
    plant: 'ALL',
    facilityId: '',
    userCai: ''
  }
  oeriStatistics: any = {
    lastCalled: '',
    openTlr : 0,
    removedIn30days : 0
  };
  constructor(private oeriService: OERIService,private notificationService:NotificationService , private report: ReportsService, private router: Router, 
    private commonService: CommonService) {
      this.filters.userCai = this.commonService.getUserCai();
      this.filters.facilityId = this.commonService.getCurrentFacility();
      
  }

  ngOnInit() {
    this.getOERIStatistics();
    this.getDivisionList();
  }
  getOERIStatistics(){
    this.oeriService.getOeriStatistics().subscribe((response: any) => {
      this.oeriStatistics.lastCalled = this.commonService.formatDateTime(response.oeriLastCalledTLR);
      this.oeriStatistics.openTlr = response.openTLRsToOERI;
      this.oeriStatistics.removedIn30days = response.removedTLRsLast30DaysToOERI;

    }, (error: any) => {
      console.error('Error fetching OERI data:', error);
    });
  }
  getDivisionList() {
    this.report.getLDAREmissionbuildSearch('ES', false).subscribe(
      (data: any) => {
        this.divisionList = data.divisionItems;
        this.sectionsList = data.sectionItems;
        this.plantList = data.plantItems;
      },
      (error: any) => {
        console.error('Error fetching air compliance details', error);
      }
    );
  }

  runReport() {
    this.oeriService.getOrphanReports(this.filters).subscribe((response: any) => {
      this.reportData = response || [];
      this.isShowMainBlock = true;
    }, (error: any) => {
      console.error('Error fetching OERI data:', error);
    });
  }


  details(row: any) {
    this.router.navigate(['/details-section', row.Tag_Number]);
  }

  exportToExcel() {
    this.oeriService.getOrphanReportsExcel(this.filters)
      .subscribe({
        next: (fileData: any) => {
          if (fileData) {
            saveAs(fileData, 'TLR-OERIOrphaned.xlsx');
          }
          this.notificationService.showSuccess("file downloaded successfully");
        },
        error: (err: any) => {
          console.error('Error fetching report details:', err);
        }
      });
  }


  backBtn() {
    this.isShowMainBlock = false;
  }
  getDateClass(date: Date): string {
    date = new Date(date); // Convert to Date object if it's a string
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight for comparison

    if (date < today) {
      return 'past-date';
    } else  {
        return 'future-date';
      }
  }
}
